import React from 'react';
import Loadable from 'react-loadable';
import RouteLoading from 'components/RouteLoading';

export default {
  exact: true,
  path: '/home/creator/settle',
  owner: '/home',
  authority: 'settleList',
  component: Loadable({
    loader: () => import('./index'),
    loading: () => <RouteLoading />
  })
};